// extracted by mini-css-extract-plugin
module.exports = {"container":"color-glow_container__YQw0s","color":"color-glow_color__nbUIN"};